<template>
  <footer class="footer">
    <div class="container _pt-15 _pb-12 _px-md-4">
      <p class="footer__secondary _fs-16 _lh-24 _mb-4">
        {{ $t("footer.inst") }}
      </p>
      <p class="footer__copy _mb-4 _fs-16 _lh-24">
        {{ $t("footer.copyright") }}
      </p>

      <div class="_mb-4">
        <a
          href="/policy-cookie"
          target="_blank"
          class="footer_policy _fs-16 _lh-24"
        >
          {{ $t("footer.privacy") }}
        </a>
      </div>
      <p class="footer__secondary _fs-16 _lh-24 _mb-4">
        {{ $t("footer.description") }}
      </p>
      <p class="footer__secondary _fs-16 _lh-24">
        {{ $t("footer.secondary_description") }}
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
  computed: {
    currentLocale() {
      return this.Trans.currentLocale.trim();
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  border-top: 1px solid color(grey-second);
  background-color: color(light);

  &__copy {
    font-family: "Noto-Sans", sans-serif;
    color: color(dark-blue);
  }

  &_policy {
    font-family: "Noto-Sans", sans-serif;
    color: color(dark-blue);
    text-decoration: underline;
    transition: all 0.3s ease;

    &:hover {
      color: lighten(color(dark-blue), 10);
    }
  }

  &__secondary {
    font-family: "Noto-Sans", sans-serif;
    color: color(grey);
  }
}
</style>
